export const OtaUpdateDialog = () => null;
